'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mockStorage = {
  setItem: function setItem() {},
  removeItem: function removeItem() {},
  getItem: function getItem() {
    return null;
  }
};
var SESSION_STORAGE_KEY = 'sessionStorage';
var LOCAL_STORAGE_KEY = 'localStorage';
var AVAILABLE_STORAGES = [SESSION_STORAGE_KEY, LOCAL_STORAGE_KEY];
var getStorage = function getStorage(type) {
  var storage = void 0;
  try {
    storage = AVAILABLE_STORAGES.includes(type) && global[type];
  } catch (error) {
    storage = mockStorage;
  }
  return storage;
};
var sessionStorage = exports.sessionStorage = getStorage(SESSION_STORAGE_KEY);
var localStorage = exports.localStorage = getStorage(LOCAL_STORAGE_KEY);

var storage = exports.storage = {
  get: function get(key, fallback) {
    return JSON.parse(localStorage.getItem(key) || fallback);
  },
  set: function set(key, value) {
    return localStorage.setItem(key, JSON.stringify(value));
  },
  delete: function _delete(key) {
    return localStorage.removeItem(key);
  }
};